export default "__VITE_PUBLIC_ASSET__b32085e8__"